import styled from "@emotion/styled";
import { Filters } from "../../styled";

export const DraftsTabContainer = styled.div`
  @media (max-width: 639px) {
    ${Filters} {
      justify-content: center;
    }
  }
`;
